import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    background-color: ${globalThis.config.colors.gray7};
    padding: 0;
    border-radius: 1rem;
    box-shadow: inset 0 0.1rem 0.3rem rgba(0, 0, 0, 0.2);
`;

export const Bar = styled.span`
    display: block;
    background-color: ${globalThis.config.colors.blue1};
    border-radius: 1rem;
    transition: width 500ms ease-in-out;
    width: ${(props) => `${props.$percent}%`};
    height: ${(props) => props.$height};
`;
